import { getWrapperClassName, IconProps } from '@/components/design-system/utils'
import React from 'react'

export const TLIconLinkedIn = (props: IconProps) => {
  const height = `${ props.height }px`
  const width = `${ props.width }px`
  return (
      <svg
          className={ getWrapperClassName(props.className, '') }
          viewBox="0 0 36 36"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          height={ height }
          width={ width }>
        { props.tooltip && <title>{ props.tooltip }</title> }
        <path
            d="M2 6.39439C2 3.96743 3.96743 2 6.39439 2H28.9941C31.421 2 33.3885 3.96743 33.3885 6.39439V28.9941C33.3885 31.421 31.421 33.3885 28.9941 33.3885H6.39439C3.96743 33.3885 2 31.421 2 28.9941V6.39439Z"
            fill="currentColor"/>
        <path
            d="M13.2998 10.4749C13.2998 12.0351 12.0351 13.2998 10.4749 13.2998C8.9147 13.2998 7.64992 12.0351 7.64992 10.4749C7.64992 8.9147 8.9147 7.64992 10.4749 7.64992C12.0351 7.64992 13.2998 8.9147 13.2998 10.4749Z"
            fill="white"/>
        <path
            d="M8.27769 15.1832C8.27769 14.8365 8.55876 14.5554 8.90546 14.5554H12.0443C12.391 14.5554 12.6721 14.8365 12.6721 15.1832V27.1108C12.6721 27.4575 12.391 27.7385 12.0443 27.7385H8.90546C8.55876 27.7385 8.27769 27.4575 8.27769 27.1108V15.1832Z"
            fill="white"/>
        <path
            d="M15.1832 14.5554L18.0081 14.5554C18.3548 14.5554 18.6359 14.8365 18.6359 15.1832V15.8109C19.8914 14.2415 22.1932 14.1369 23.3442 14.2415C26.9321 14.5676 27.5293 18.2174 27.4247 20.2053L27.4246 27.1108C27.4246 27.4575 27.1436 27.7385 26.7969 27.7385L23.9719 27.7386C23.6252 27.7386 23.3442 27.4575 23.3442 27.1108V20.2053C23.2395 19.3683 22.6536 17.6942 21.147 17.6942C19.6403 17.6942 18.7405 19.5775 18.6359 20.2053V27.1108C18.6359 27.4575 18.3548 27.7386 18.0081 27.7386L15.1832 27.7385C14.8364 27.7385 14.5554 27.4575 14.5554 27.1108V15.1832C14.5554 14.8365 14.8365 14.5554 15.1832 14.5554Z"
            fill="white"/>
      </svg>
  )
}

TLIconLinkedIn.defaultProps = {
  className: '',
  height: 36,
  width: 36,
  tooltip: null
}
